// import $ from "jquery";
import { getConfig, getContent, getMeta, getDynData } from "../../scripts/general_functions.js";
import { compile_content } from "../../scripts/tools/compile_content.js";

export default function(client) {
    console.log(client);
    const config = getConfig();
    const res = client;
    const logo = res.logo[0];
    const footerlogo = res.logo[1];
    let style = "";
    let cssclass = "";
    if (logo != undefined) {
        style = (logo.inlineStyles && logo.inlineStyles.length > 0 ? "style='" + logo.inlineStyles + "'" : "");
        cssclass = (logo.cssclass && logo.cssclass.length > 0 ? logo.cssclass : "");
    }

    getContent(config.footer).done(function(data) {
        let meta = getMeta(data);
        let dyndata = getDynData(meta);

        let text1 = dyndata["fritekst_venstre"];
        let text3 = dyndata["fritekst_senter"];
        let text2 = dyndata["fritekst_hoyre"];

        text2 = compile_content(text2, data);

        let leftcolumn = ``;

        if (text1) {
            leftcolumn = text1;
        }
        let rightcolumn = ``;
        if (text2) {
            rightcolumn = text2;
        }
        let centercolumn = ``;
        if (text3) {
            centercolumn = text3;
        }
        let footerLinks = ``;
        if(config?.footerLinks) {
            config?.footerLinks.forEach(element => {
                footerLinks += `<a href="${element.link}" title="${element.text}" target="_blank"><img src="${element.image}" alt="${element.text}" /></a>`;
            });
        }

        const footerHtml = `
            <div class="footer__pre">
            </div>
            <div class="totop__container container">
                <div class="">
                    <div class="">
                        <a href="javascript:window.scrollTo(0,0);" aria-label="Til toppen" class="totop__link d-table">
                            <span class="material-icons-outlined totop__icon">&#xE5D8;</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="footer--container">
                <div class="footer__post">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="footer--container--inner footer__content">
                                    <div class="row">
                                        <div class="col-sm-4 col-md-4 p-md-0">
                                            ${config.logoInFooter ? `
                                                <div class="footer__shield-container align-middle">
                                                    <img class="footer__shield align-middle ${cssclass}" alt="${footerlogo.alttext}" src="${footerlogo.filepath}"  ${style} > 
                                                </div>` : ``}
                                            ${leftcolumn}
                                        </div>
                                        <div class="col-sm-4">
                                            ${centercolumn}
                                        </div>
                                        <div class="col-sm-4">
                                            ${rightcolumn}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer__cookie">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-4 p-0 text-left"></div>
                            <div class="col-md-4 text-center">
                                <a href="/personvernerklaering-og-informasjonskapsler">Personvernerklæring og informasjonkapsler</a>
                            </div>
                            <div class="col-md-4 p-0 text-center text-md-right footer__links">${footerLinks}</div>
                        </div>
                    </div> 
                </div>
            </div>`;

        $("#footer").append(footerHtml);
        let analytics = '';
        // console.log("client",config);
        if (config.analytics) {
            analytics = config.analytics;

            let gscript = `
            <script async src="https://www.googletagmanager.com/gtag/js?id=${analytics}"></script>
            <script>
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${analytics}');
            </script> `
            $("body").append(gscript);
        }
    });
}
